import { Select, TextInput } from 'nhsuk-react-components';

interface RoutingPlanFilterProps {
  maxAge: string;
  wordsFilter: string;
  onMaxAgeChange: (value: string) => void;
  onWordsFilterChange: (value: string) => void;
}

function RoutingPlanFilter({
  maxAge, wordsFilter, onMaxAgeChange, onWordsFilterChange,
}: RoutingPlanFilterProps) {
  return (
    <>
      <p className="nhsuk-u-font-weight-bold">Find message plans</p>
      <p>Search and filter available message plans.</p>
      <div>
        <Select
          id="age-version-select"
          test-id="message-plans-age-select"
          label="Hide message plans that have not been refreshed for:"
          onChange={(e) => onMaxAgeChange((e.target as HTMLSelectElement).value)}
          value={maxAge}
        >
          <Select.Option value="3" key="3 Months">
            3 months
          </Select.Option>
          <Select.Option value="6" key="6 Months">
            6 months
          </Select.Option>
          <Select.Option value="12" key="12 Months">
            12 months
          </Select.Option>
          <Select.Option value="24" key="24 Months">
            24 months
          </Select.Option>
          <Select.Option value="" key="All">
            No restriction
          </Select.Option>
        </Select>
      </div>
      <TextInput
        label="Start typing to search for a message plan. To remove results, type a minus sign before a word, for example '-COVID'. Leave the field blank to see all available message plans."
        test-id="message-plans-text-filter"
        onChange={(e) => onWordsFilterChange((e.target as HTMLInputElement).value)}
        value={wordsFilter}
      />
    </>
  );
}

export default RoutingPlanFilter;
